import { useIsLoggedIn, useSubscriptionsSelector } from "@nf/common";
import { ROUTES } from "@nf/constants";
import { useTranslation } from "next-i18next";

import Button, { ButtonSize } from "components/Button";
import { useCurrentSubscriptions, useSignUpUrl } from "../../hooks";
import { useMemo } from "react";

interface OfferButtonProps {
  size?: ButtonSize;
  isAvailable?: boolean;
}

export const OfferButton = ({
  size = "large",
  isAvailable = true,
}: OfferButtonProps) => {
  const { t } = useTranslation("translations");
  const { subscriptions } = useSubscriptionsSelector();
  const { hasCurrentSubscriptions } = useCurrentSubscriptions(subscriptions);

  const isLoggedIn = useIsLoggedIn();
  const signUpUrl = useSignUpUrl();

  const targetUrl = hasCurrentSubscriptions
    ? ROUTES.SETTINGS_SUBSCRIPTION
    : isLoggedIn
    ? ROUTES.PAYMENT_SUBSCRIPTION
    : signUpUrl;

  const label = useMemo(() => {
    if (!isAvailable) {
      return t("web_asset_page_not_available");
    }

    return t("web_common_start_watching");
  }, [isAvailable]);

  return (
    <Button size={size} variant="primary" href={targetUrl}>
      {label}
    </Button>
  );
};

export default OfferButton;
